import React from "react";
import { IoReturnUpBackOutline } from "react-icons/io5";
import { Link, useNavigate } from "react-router-dom";

const BreadCrumb = ({ product }) => {
  const navigate = useNavigate();
  // TODO: get the Category, sub-category and sub-sub-categories

  return (
    <div className="flex flex-wrap items-center gap-2 mb-gap">
      <IoReturnUpBackOutline
        className="font-bold cursor-pointer"
        size={25}
        onClick={() => navigate(-1)}
      />
      <Link
        to={"/"}
        className="tracking-wider underline hover:bg-black hover:text-white"
      >
        Home
      </Link>
      /
      <Link
        to={`/${product?.category?.parent?.slug}`}
        className="tracking-wider underline capitalize hover:bg-black hover:text-white"
      >
        {product?.category?.parent?.name?.toLowerCase()}
      </Link>
      /
      <Link
        to={`/${product?.category?.parent?.slug}/${product?.category?.slug}`}
        className="tracking-wider underline capitalize hover:bg-black hover:text-white"
      >
        {product?.category?.name?.toLowerCase()}
      </Link>
      {/* /
      <Link
        to={`/${product?.category?.slug}/${product?.slug}`}
        className="tracking-wider underline capitalize hover:bg-black hover:text-white"
      >
        {product?.name?.toLowerCase()}
      </Link> */}
    </div>
  );
};

export default BreadCrumb;
